module.exports = __webpack_public_path__ + "img/wban-logo-ethereum.847732a8.svg";